import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/access-denied/page.tsx");
